import { createApp } from 'vue'
import { createPinia } from 'pinia'
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";
import moment from 'moment'
import moment_nl from "moment/dist/locale/nl";

// Choose moment Locale
moment.locale('nl', moment_nl);


import ComponentAssetMaterials from './AssetMaterials.vue'
import ComponentDrupalElementSelectMaterial from './DrupalElementSelectMaterial.vue'
import ComponentDrupalElementSelectUser from './DrupalElementSelectUser.vue'
import ComponentDrupalElementDimmingSchema from './DrupalElementDimmingSchema.vue'
import ComponentOutageReport from './OutageReport.vue'
import ComponentDashboard from './Dashboard.vue'
import ComponentWorkorderCreate from './WorkorderCreate.vue'
import ComponentOutageReportChartPage from './OutageReportChartPage.vue'

// Vuetify
import 'vuetify/styles'
import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import * as labsComponents from 'vuetify/labs/components'
import { nl, en } from 'vuetify/locale'

import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css'
import VueKeyboardTrapDirectivePlugin from "@pdanpdan/vue-keyboard-trap";

const toast_default_options = {
  position: 'top-center',
}

const vuetify = createVuetify({
  components: {
    ...components,
    ...labsComponents,
  },
  locale: {
    locale: 'nl',
    fallback: 'en',
    messages: { nl, en },
  },
  directives,
  icons: {
    defaultSet: 'mdi', // This is already the default value - only for display purposes
  },
  defaults: {
    VBtn: {
      color: 'primary',
      variant: 'flat',
      style: 'text-transform: none;',
    },
  },
  theme: {
    themes: {
      light: {
        dark: false,
        colors: {
          primary: "#388038",
          secondary: "#003ecc",
        },
        variables: {
          'high-emphasis-opacity': '1',
          'medium-emphasis-opacity': '1',
          'border-opacity': '0.9',
        },
      },
    },
  },
  options: {
    customProperties: true
  },
})

const dateFilters = {
  formatDate(date) {
    return moment(String(date)).format('DD MMMM YYYY HH:mm')
  },
  formatDateOnly(date) {
    return moment(String(date)).format('DD MMMM YYYY')
  },
}







/**
 * Create a new instance of the asset material app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param dom_id
 */
window.createAppAssetMaterials = function(dom_id) {
  const tag = document.querySelector(dom_id);
  if (tag) {

    const app = createApp(
      ComponentAssetMaterials,
      {
        asset_id: tag.dataset.assetId, // Set the 'props' values is the value of the props in the component
        client_id: tag.dataset.clientId, // Needed when selecting other material
        activity_id: tag.dataset?.activityId,
        activity_type: tag.dataset?.activityType,
      }
    )

    // Make it globally accessible. For example to use in jQuery.
    window.appAssetMaterials = app;

    // Import libraries
    app.use(vuetify)
    app.use(createPinia())
    app.use(Toast, toast_default_options);
    app.use('VueDatePicker', VueDatePicker);

    // Register date formats via Vue filters
    app.config.globalProperties.$filters = dateFilters;

    app.mount(dom_id)
  }
}

// On page load, mount the asset material app when the element is already found in the DOM.
const assetMaterialId = "#vue-asset-materials";
const assetMaterialsTag = document.querySelector(assetMaterialId);
if (assetMaterialsTag) {
  // Create a new app instance
  window.createAppAssetMaterials(assetMaterialId);
}







/**
 * Create a new instance of the select material element app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param dom_id
 */
window.createAppDrupalElementSelectMaterial = function(dom_id) {
  const tag = document.querySelector(dom_id);
  if (tag) {

    const app = createApp(
      ComponentDrupalElementSelectMaterial,
      {
        client_id: tag.dataset.clientId, // Needed when selecting new material
        drupal_input_id: tag.dataset.drupalInputId,
        material_types: tag.dataset.materialTypes,
        material_cardinality: parseInt(tag.dataset.materialCardinality),
        material_empty_text: tag.dataset.materialEmptyText
      }
    )

    // Make it globally accessible. For example to use in jQuery.
    window.appAssetMaterials = app;

    // Import libraries
    app.use(vuetify)
    app.use(createPinia())
    app.use(Toast, toast_default_options);
    app.use('VueDatePicker', VueDatePicker);

    // Register date formats via Vue filters
    app.config.globalProperties.$filters = dateFilters;

    app.mount(dom_id)
  }
}

// On page load, mount the asset material app when the element is already found in the DOM.
const assetSelectMaterialId = "#vue-select-material";
const assetSelectMaterialTag = document.querySelector(assetSelectMaterialId);
if (assetSelectMaterialTag) {
  // Create a new app instance
  window.createAppDrupalElementSelectMaterial(assetSelectMaterialId);
}




/**
 * Create a new instance of the select user element app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param dom_id
 */
window.createAppDrupalElementSelectUser = function(dom_id) {
  const tag = document.querySelector(dom_id);
  if (tag) {

    const app = createApp(
      ComponentDrupalElementSelectUser,
      {
        client_id: tag.dataset.clientId, // Needed when selecting new material
        drupal_input_id: tag.dataset.drupalInputId,
        user_cardinality: parseInt(tag.dataset.userCardinality),
        user_empty_text: tag.dataset.userEmptyText
      }
    )

    // TODO: We dont need this global variable anymore?
    // Make it globally accessible. For example to use in jQuery.
    window.appAssetMaterials = app;

    // Import libraries
    app.use(vuetify)
    app.use(createPinia())
    app.use(Toast, toast_default_options);

    // Register date formats via Vue filters
    app.config.globalProperties.$filters = dateFilters;

    app.mount(dom_id)
  }
}

// On page load, mount the select user app when the element is already found in the DOM.
const assetSelectUserId = "#vue-select-user";
const assetSelectUserTag = document.querySelector(assetSelectUserId);
if (assetSelectUserTag) {
  // Create a new app instance
  window.createAppDrupalElementSelectUser(assetSelectUserId);
}




/**
 * Create a new instance of the dimming schema element app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param dom_id
 */
window.createAppDrupalElementDimmingSchema = function(dom_id) {
  const tag = document.querySelector(dom_id);
  if (tag) {

    const app = createApp(
      ComponentDrupalElementDimmingSchema,
      {
        drupal_input_id: tag.dataset.drupalInputId,
        empty_text: tag.dataset.emptyText
      }
    )

    // Import libraries
    app.use(vuetify)
    app.use(createPinia())
    app.use(Toast, toast_default_options);
    app.use('VueDatePicker', VueDatePicker);

    // Register date formats via Vue filters
    app.config.globalProperties.$filters = dateFilters;

    app.mount(dom_id)
  }
}

// On page load, mount the dimming schema app when the element is already found in the DOM.
const assetDimmingSchemaId = "#vue-dimming-schema";
const assetDimmingSchemaTag = document.querySelector(assetDimmingSchemaId);
if (assetDimmingSchemaTag) {
  // Create a new app instance
  window.createAppDrupalElementDimmingSchema(assetDimmingSchemaId);
}





/**
 * Create a new instance of the outage report app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param dom_id
 */
window.createAppOutageReport = function(dom_id) {
  const tag = document.querySelector(dom_id);
  if (tag) {

    const app = createApp(
      ComponentOutageReport,
      {
        client_id: parseInt(outageReportTag.dataset.clientId), // Set the 'props' values is the value of the props in the component
        user_logged_in: (outageReportTag.dataset.userLoggedIn === "1"),
        multi_lightpoles: (outageReportTag.dataset.multiLightpoles === "1"),
        zoom_location: (outageReportTag.dataset.zoomLocation) ? JSON.parse(outageReportTag.dataset.zoomLocation) : [],
      }
    )

    // Make it globally accessible. For example to use in jQuery.
    window.appAssetMaterials = app;

    // Import libraries
    app.use(vuetify)
    app.use(VueKeyboardTrapDirectivePlugin, {

    });
    app.use(createPinia())
    app.use(Toast, toast_default_options);

    // Register date formats via Vue filters
    app.config.globalProperties.$filters = dateFilters;

    app.mount(dom_id)
  }
}

// On page load, mount the asset material app when the element is already found in the DOM.
const outageReportId = "#vue-outage-report";
const outageReportTag = document.querySelector(outageReportId);
if (outageReportTag) {
  // Create a new app instance
  window.createAppOutageReport(outageReportId);
}







/**
 * Create a new instance of the asset material app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param dom_id
 */
window.createAppDashboard = function(dom_id) {
  const tag = document.querySelector(dom_id);
  if (tag) {
    const app = createApp(
      ComponentDashboard,
      {
        client_id: parseInt(tag.dataset.clientId), // Needed when selecting other material
        organisation_id: parseInt(tag.dataset.organisationId),
      }
    )

    // Make it globally accessible. For example to use in jQuery.
    window.appDashboard = app;

    // Import libraries
    app.use(vuetify)
    app.use(createPinia())
    app.use(Toast, toast_default_options);

    // Register date formats via Vue filters
    app.config.globalProperties.$filters = dateFilters;

    app.mount(dom_id)
  }
}

// On page load, mount the asset material app when the element is already found in the DOM.
const dashboardId = "#vue-dashboard";
const dashboardTag = document.querySelector(dashboardId);
if (dashboardTag) {
  // Create a new app instance
  window.createAppDashboard(dashboardId);
}







/**
 * Create a new instance of the asset material app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param dom_id
 */
window.createAppWorkorderCreate = function(dom_id) {
  const tag = document.querySelector(dom_id);
  if (tag) {

    const app = createApp(
      ComponentWorkorderCreate,
      {
        can_assign_users: workorderCreateTag.dataset.canAssignUsers,
        status_options: JSON.parse(workorderCreateTag.dataset.statusOptions),
      }
    )

    // Make it globally accessible. For example to use in jQuery.
    window.appAssetMaterials = app;

    // Import libraries
    app.use(vuetify)
    app.use(createPinia())
    app.use(Toast, toast_default_options);

    // Register date formats via Vue filters
    app.config.globalProperties.$filters = dateFilters;

    app.mount(dom_id)
  }
}
// On page load, mount the asset material app when the element is already found in the DOM.
const workorderId = "#vue-workorder-create";
const workorderCreateTag = document.querySelector(workorderId);
if (workorderCreateTag) {
  // Create a new app instance
  window.createAppWorkorderCreate(workorderId);
}

/**
 * Create a new instance of the asset material app.
 * This function can be called outside Vue to create a new app instance, for example in jQuery.
 *
 * @param dom_id
 */
window.createAppOutageReportChartPage = function(dom_id) {
  const tag = document.querySelector(dom_id);
  if (tag) {
    const app = createApp(
      ComponentOutageReportChartPage,
      {
        active_lightpoles: parseInt(tag.dataset.activeLightpoles),
        active_outages: parseInt(tag.dataset.activeOutages),
        failure_rate_current: tag.dataset.failureRateCurrent,
        all_outages_in_period: parseInt(tag.dataset.allOutagesInPeriod),
        failure_rate_in_period: tag.dataset.failureRateInPeriod,
        start_formatted_date: tag.dataset.startFormattedDate,
        end_formatted_date: tag.dataset.endFormattedDate,
        outage_late: parseInt(tag.dataset.outageLate),
        outage_not_late: parseInt(tag.dataset.outageNotLate),
      }
    )

    // Make it globally accessible. For example to use in jQuery.
    window.appDashboard = app;

    // Import libraries
    app.use(vuetify)
    app.use(createPinia())
    app.use(Toast, toast_default_options);

    // Register date formats via Vue filters
    app.config.globalProperties.$filters = dateFilters;

    app.mount(dom_id)
  }
}

// On page load, mount the asset material app when the element is already found in the DOM.
const outageReportChartePageId = "#vue-outage-report-chart-page";
const outageReportChartePageTag = document.querySelector(outageReportChartePageId);
if (outageReportChartePageTag) {
  // Create a new app instance
  window.createAppOutageReportChartPage(outageReportChartePageId);
}
